<template>
  <div class="page-header page-home">
    <div class="text">
      <div class="title">中国联通客户 5G/4G/3G 优惠活动业务协议</div>
      <div v-html="text">{{ text }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "unicomDeal5",
  data() {
    return {
      text: "",
    };
  },
  created() {
    this.text = `甲方：
    乙方：
    本协议作为《中国联通客户入网服务协议》的补充协议，甲乙双方在平等自愿、公平诚信的基础上，基于对乙方移动通信服务的了解和需求，达成协议如下：
    <span style="font-weight: 800;">第一条</span> 甲方所选择的 5G/4G/3G 业务套餐及相关资费、5G/4G/3G 优惠活动及协议期限等内容详见《	综合业务受理单》。
    <span style="font-weight: 800;">第二条</span> 甲方自愿参加乙方的 5G/4G/3G 优惠活动。5G/4G/3G 优惠活动是指乙方通过“话费优惠（例如存费送费、购机送费）、终端优惠（例如存费送机）、赠送业务或礼品”等方式向甲方提供各类优惠通信产品。只有在甲方依据本协议绑定使用所购买的通信服务、通信卡、用户号码以及通信终端（即机卡不分离），同时在协议期内（协议期详见综合业务受理单）连续在网使用乙方通信服务的情况下，甲方方可享受乙方提供的各项优惠补贴政策。
    <span style="font-weight: 800;">第三条 使用条件</span>
    （一）为保障甲乙双方的权益，协议期内乙方对甲方使用的用户号码与 5G/4G/3G 移动通信终端 IMEI 码进行机卡匹配核实。若甲方所购终端可同时支持多个通信卡时，甲方须将本协议涉及的通信卡放在正确卡槽中使用方可实现机卡匹配。
    （二）本协议中甲方预存款可延期消费，不可退还。甲方赠送的话费当月有效，用于抵扣甲方当月消费的通信费用（不含国际长途、国际漫游和第三方合作 SP 业务所产生的费用），不可延期消费，不可结转，不可退还。协议期满后终止赠送话费。
    （三）甲方参加预付费产品优惠活动时，当账户余额不足以扣除基本套餐月费时，甲方无法正常使用通信服务，乙方正常解冻预存款，仍需扣除套餐月费。
    （四）协议期内甲方有套餐变更需求时，变更后的套餐须不低于本协议中约定的套餐（或承诺的月最低消费）。甲方变更套餐后，分月解冻的预存款金额及/或乙方分月赠送的话费保持不变。
    （五）甲方当月实际产生的通信费超出当月预存款解冻金额或/及乙方分月赠送的话费时，甲方须按时缴清当月超出的通信费。如因甲方未按时缴清相关费用导致欠费停机，则甲方构成违约。
    （六）在协议期内，存费送机用户不能办理停机保号业务；参加话费优惠、终端优惠活动的用户均不能办理销户业务。
    （七）甲方参加乙方赠送话费优惠活动时，甲方如申请办理停机保号业务，预存款正常按月解冻，停止赠送话费，收取停机保号费，不再收取套餐费。甲方当月办理开机业务后，当月恢复赠送话费；如甲方次月办理开机业务，仅从次月开始赠送话费，不再追补，本协议期不顺延。
    <span style="font-weight: 800;">第四条 违约责任及承担</span>
    （一）甲方违约责任
    1、甲方在协议期内发生欠费停机、未绑定使用本协议中所购买的通信卡和	5G/4G/3G 移动通信终端（机卡分离）、销户等行为时，则甲方构成违约。
    2、在协议期内，乙方每月进行机卡匹配核实，若甲方发生机卡分离的违约行为，乙方有权取消对甲方的优惠，并作停机处理。
    3、在机卡分离停机后 3 个月内，甲方须持有效身份证件、优惠活动中绑定的通信卡和
    5G/4G/3G 移动通信终端到乙方营业厅，在足额缴纳欠费、违约金及约定的相关费用后，可申请恢复开机。恢复开机当月起，双方继续履行本协议，协议期限不顺延。
    4、在逾期欠费及/或机卡分离导致停机时，预存款正常按月解冻。对于因逾期欠费及/或机卡分离导致停机满 3 个月的，乙方有权对甲方用户号码进行销户，并终止向甲方赠送话费和解冻预存款，预存款不退还。
    5、甲方参加乙方赠送话费优惠活动时，若甲方发生违约行为，乙方将暂停赠送话费。甲方当月补交所欠费用或办理开机业务后且未发生其他违约行为，当月恢复赠送话费；如甲方次月补交所欠费用或办理开机业务后且未发生其他违约行为，仅从次月开始赠送话费，不再追补，本协议期不顺延。
    6、甲乙双方一致确认，甲方出现本协议所述的违约情形时，甲方应向乙方支付违约金以补偿乙方的损失，乙方有权以甲方账户中尚未解冻的预存款直接抵扣欠费、违约金及约定的相关费用，不足部分，乙方保留对甲方追缴的权利。违约金包括但不限于：因用户欠费发生的逾期付款违约金，以及乙方在本协议中所给予甲方的优惠等（如终端优惠、话费优惠、赠送业务及礼品等）。
    （二）乙方违约责任
    1、乙方构成违约的，应按《中华人民共和国电信条例》及其他有关规定，承担违约责任。
    2、乙方向甲方直接出售或提供的 5G/4G/3G 移动通信终端出现质量问题时，甲方应送相关厂商指定的售后网点进行处理，或持厂商指定售后网点出具的检测证明材料到乙方营业网点，乙方按《产品质量法》、《消费者权益保护法》等国家法律法规的规定，承担相应责任并进行处理。
    <span style="font-weight: 800;">第五条 协议生效</span>
    本协议自双方签字盖章之日起生效，本协议到期时，如甲乙双方均未提出对套餐资费的修改要求，将继续执行本协议约定的套餐资费。
    （甲方承诺：本人已经充分、完整阅读并理解本协议所述全部条款及条件。）


    甲方：	                     乙方：

    甲方代理人或经办人：    
    甲方用户号码：
    签署日期：	              签署日期：`;
  },
};
</script>

<style lang="scss" scoped>
.page-home {
  width: 100%;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;

  .text {
    padding: 1rem;
    font-size: 1rem;
    line-height: 1.5rem;
    white-space: pre-wrap;
    .title {
      font-weight: 800;
      text-align: center;
      margin: 1rem auto;
    }
  }
}
</style>
